export default __webpack_public_path__ + "static/media/no-data-error.314ff4d0.png";